import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

const NewContactPageHero = () => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${
        theme === "dark" ? "bg-white" : "bg-black"
      } transition-all duration-500 relative overflow-hidden`}
    >
      <div className="max-w-screen-2xl mx-auto px-5 sm:px-20 py-8 sm:py-28 h-[450px] sm:h-[500px]">
        <div className="flex flex-col items-center">
          {/* <div className="hover:!shadow-[0px_0px_20px_#8d19da] rounded-full transition-all duration-500 mt-44 sm:mt-14 mb-4">
            <SecondaryButton
              className={`${
                theme === "dark"
                  ? "border border-secondary"
                  : "!bg-black text-white !shadow-[inset_0px_0px_10px_#F20B97] shadow-secondary border border-secondary"
              } text-sm text-black sm:text-[16px] transition-all duration-500 relative z-10 bricolage-grotesque-bold px-6`}
            >
              Let's Talk
            </SecondaryButton>
          </div> */}
          <h1
            className={`${
              theme === "dark" ? "text-black" : "text-white"
            } transition-all duration-500 text-[32px] sm:text-5xl text-center bricolage-grotesque-bold mt-32 sm:mt-14`}
          >
            Got a Vision? We’ve Got the Expertise. <br/> 
            <span className="text-gradient"> Let’s Bring It to Reality Together!</span>
          </h1>
        </div>
      </div>
      <svg
        width="1444"
        height="1292"
        viewBox="0 0 1444 1292"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-[300px] sm:top-[150px] -left-[25%] sm:left-0 sm:right-0 sm:mx-auto h-full sm:h-auto w-[600px] sm:w-full"
      >
        <g filter="url(#filter0_f_3562_1617)">
          <ellipse cx="722" cy="646" rx="643" ry="393" fill="#8D19DA" />
        </g>
        <defs>
          <filter
            id="filter0_f_3562_1617"
            x="-173.6"
            y="0.399994"
            width="1791.2"
            height="1291.2"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="126.3"
              result="effect1_foregroundBlur_3562_1617"
            />
          </filter>
        </defs>
      </svg>
      <svg
        width="790"
        height="786"
        viewBox="0 0 790 786"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute mx-auto -left-[15%] sm:left-0 right-0 top-[380px] sm:top-[350px] h-full sm:h-auto w-[500px] sm:w-auto positive-animate-spin1"
      >
        <path
          d="M789.5 393C789.5 609.769 612.879 785.5 395 785.5C177.121 785.5 0.5 609.769 0.5 393C0.5 176.231 177.121 0.5 395 0.5C612.879 0.5 789.5 176.231 789.5 393Z"
          stroke="#727272"
        />
        <g filter="url(#filter0_f_3804_1744)">
          <circle cx="136" cy="95" r="9" fill="#F20B97" />
        </g>
        <defs>
          <filter
            id="filter0_f_3804_1744"
            x="113"
            y="72"
            width="46"
            height="46"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="7"
              result="effect1_foregroundBlur_3804_1744"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default NewContactPageHero;
